import {useEffect, useState} from "react";
import {showErrorNotification} from "../helpers/mainHelpers";
import {operationStaffService} from "../services/operationStaff-service";
import {OperationStaffItem} from "../types/operation";

export const useOperationStaffController = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [operationStaffList, setOperationStaffList] = useState<OperationStaffItem[]>([])


  useEffect(() => {
    fetchOperationStaffList([])
  }, [])


  const fetchOperationStaffList = async (queries: string[]) => {
    setIsLoading(true)
    try {
      const list = await operationStaffService.list(queries)
      setOperationStaffList(list)
    } catch (error) {
      console.error(error)
      showErrorNotification({message: "Помилка завантаження лікарів!"});
    } finally {
      setIsLoading(false)
    }
  }

  const sortedOperationStaff = [...operationStaffList].sort((a, b) =>
    a.fullName.localeCompare(b.fullName, 'uk'),
  )

  return {fetchOperationStaffList, isLoading, operationStaffList: sortedOperationStaff}
}
export default useOperationStaffController